import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DocumentEntity, SignedByPartial } from '@domain';
import { environment } from '@environments';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DocumentContractApi {
    private prefix = 'document/contract';
    private _httpClient = inject(HttpClient);

    /**
     * Reenvia o codigo de acesso do contrato
     * @param documentId id do contrato
     * @param email email para qual vai ser enviado
     * @returns Observable<void>
     */
    public resendCode(documentId: string, email: string): Observable<void> {
        try {
            const url = `${environment.API_BASE}${this.prefix}/resend-code`;
            return this._httpClient.patch<void>(url, { documentId, email });
        } catch (error) {
            throw error;
        }
    }

    /**
     * Confirma o codigo de acesso do contrato
     * @param documentId id do contrato
     * @param code codigo de acesso
     * @returns Observable<void>
     */
    public verifyCode(documentId: string, code: string): Observable<HttpResponse<void>> {
        try {
            const url = `${environment.API_BASE}${this.prefix}/verify-code`;
            return this._httpClient.patch<void>(url, { documentId, code }, { observe: 'response' });
        } catch (error) {
            throw error;
        }
    }

    /**
     * Confirma o codigo de acesso do contrato
     * @param documentId id do contrato
     * @param name nome da pessoa que vai assinar
     * @param fontFamily fonte da assinatura
     * @param contractToken token temporario para assinatura do contrato
     * @returns Observable<void>
     */
    public signContract(name: string, fontFamily: string, contractToken: string): Observable<void> {
        try {
            const url = `${environment.API_BASE}${this.prefix}/sign`;
            const headers = new HttpHeaders().set('contract-token', contractToken);

            return this._httpClient.patch<void>(url, { name, fontFamily }, { headers });
        } catch (error) {
            throw error;
        }
    }

    /**
     * Verifica o status do assinante do contrato
     * @param documentId id do contrato
     * @returns Observable<HttpResponse<SignedByPartial>>
     */
    public verifySigned(documentId: string): Observable<HttpResponse<SignedByPartial>> {
        try {
            const url = `${environment.API_BASE}${this.prefix}/verify-signed/${documentId}`;

            const contractToken = localStorage.getItem(`contract_token_${documentId}`);
            const headers = new HttpHeaders().set('contract-token', contractToken);

            return this._httpClient.get<HttpResponse<SignedByPartial>>(url, { headers });
        } catch (error) {
            throw error;
        }
    }

    /**
     * Atualiza a lista de assinantes do contrato
     * @param documentId id do contrato
     * @param signedBy lista de assinantes
     * @returns Observable<void>
     */
    public updateSignedBy(documentId: string, signedBy: SignedByPartial[]): Observable<void> {
        try {
            const url = `${environment.API_BASE}${this.prefix}/update-signed-by`;

            return this._httpClient.patch<void>(url, { documentId, signedBy });
        } catch (error) {
            throw error;
        }
    }

    /**
     * Atualiza a lista de assinantes do contrato
     * @param documentId id do contrato
     * @returns Observable<DocumentEntity>
     */
    public publishContract(documentId: string): Observable<DocumentEntity> {
        try {
            const url = `${environment.API_BASE}${this.prefix}/publish/${documentId}`;

            return this._httpClient.patch<DocumentEntity>(url, null);
        } catch (error) {
            throw error;
        }
    }
}
